import React, { SVGProps } from 'react';

const ShareIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      d="M5.70996 12V19.04C5.70996 19.5068 5.89539 19.9544 6.22545 20.2845C6.55552 20.6146 7.00318 20.8 7.46996 20.8H18.03C18.4967 20.8 18.9444 20.6146 19.2745 20.2845C19.6045 19.9544 19.79 19.5068 19.79 19.04V12M16.27 6.72L12.75 3.2M12.75 3.2L9.22996 6.72M12.75 3.2V14.64"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShareIcon;
